import { Box } from '@customerio/pluma-components/react';

/** Company step. Placeholder — content lands with FPS-2863. */
export function CompanyStep() {
  return <Box data-testid="signup-step-company" />;
}
